// SubscriptionModal.jsx
import React from 'react';
import { getAuth } from 'firebase/auth';
import { handleCheckout } from './checkoutUtils';
import './StripeModal.css';

const SubscriptionModal = ({ 
  isOpen, 
  onClose, 
  onSubscriptionSuccess, 
  onRequireSignup, 
  productType // new prop: e.g. "navbar" or "builder"
}) => {
  if (!isOpen) return null;

// Navbar.js (or wherever this handler lives)
const handleUpgradeNow = async () => {
  const auth = getAuth();
  if (!auth.currentUser) {
    if (onRequireSignup) {
      onRequireSignup();
    } else {
      alert("Please sign up or log in to subscribe.");
    }
    return;
  }

  // fire the conversion event
  if (window.gtag_report_conversion) {
    // passing no URL means we stay on-page
    window.gtag_report_conversion();
  }

  // Now call handleCheckout with the productType parameter.
  // Your checkoutUtils should handle different product types accordingly.
  await handleCheckout(productType);

  // Do not immediately call onSubscriptionSuccess since Stripe's checkout will handle redirect via success_url.
  // However, you may close the modal after a short delay.
  setTimeout(() => {
    onClose();
  }, 2000);
};


  return (
    <div className="subscription-card">
      <div className="subscription-modal">
        {/* Optionally include a close button inside the modal if desired */}
        <div className="payment-option subscription">
          <h2>Upgrade to Premium for $12.99/month</h2>
          <p className="subscription-pitch">
            Level up productivity and creativity with expanded access.
          </p>
          <ul className="upgrade-features">
            <li>Access to the Resume Builder</li>
            <li>Cover Letter Maker</li>
            <li>Tailored Interview Questions for your jobs</li>
            <li>Access to our improved AI model</li>
          </ul>
          <button onClick={handleUpgradeNow} className="pay-button">
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
